import { ReactComponent as WarningIcon } from '../../../../icons/warning.svg';

import { OkDialog } from '../ok-dialog/OkDialog';

export const WarningDialog = ({ isOpen, title, message, onClick, onClose }) => {
  return (
    <OkDialog
      isOpen={isOpen}
      title={title}
      message={message}
      onClick={onClick}
      onClose={onClose}
      icon={<WarningIcon width={56} height={56} style={{ color: '#ff9800' }} />}
    />
  );
};
